<script setup lang="ts">
import { bemBuilder, toMoney } from "@chatfood/core-utils";
import { AtomText } from "@chatfood/design-system";
import { computed } from "vue";
import { useBasketStore } from "~/stores/basket";
import { useLocale } from "~/composables/use-locale";

const css = bemBuilder("basket-min-banner");
const { t } = useLocale();
const basket = useBasketStore();

const banner = computed<string | null>(() => {
  const min = basket.deliveryCoverage?.minBasket;
  if (
    !basket.isForDelivery ||
    !min ||
    min.value === 0 ||
    basket.totalBreakdown.outstandingBalance.value >= min.value
  )
    return null;

  const remaining = min.value - basket.totalBreakdown.outstandingBalance.value;
  return t("components.basket_min_banner.message", {
    amount: toMoney(remaining, min.currency),
    min: toMoney(min.value, min.currency),
  });
});
</script>

<template>
  <AtomText
    v-if="banner"
    :class="css()"
    type="small"
    color="color-text-secondary"
    data-test="basket-min-banner"
  >
    {{ banner }}
  </AtomText>
</template>

<style lang="scss" scoped>
.basket-min-banner {
  padding: var(--spacing-sm);
  background: var(--color-base-95);
  border-radius: var(--radii-card-sm);
  text-align: center;
}
</style>
